export default __webpack_public_path__ + "static/media/dataco_black_text_small.4229f417.png";